module.exports = __webpack_public_path__ + "static/media/continue-with-mail.0bb373d0.png";